/* ============================================================
   BURL — interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---- Map image slots to files in assets/images ----
     Drop a real photo at the given path and it auto-appears.
     Falls back to the CSS wood-gradient if the file is missing. */
  const IMG = window.BURL_IMG || {};

  function applyImage(el, key, targetSelector) {
    const src = IMG[key];
    if (!src) return;
    const img = new Image();
    img.onload = function () {
      const node = targetSelector ? el.querySelector(targetSelector) : el;
      if (!node) return;
      node.style.setProperty('--src', 'url("' + src + '")');
      node.classList.add('has-img');
      el.classList.add('has-img');
    };
    img.src = src;
  }

  // hero + signature (dedicated nodes)
  const heroImg = document.getElementById('heroImg');
  if (heroImg) applyImage(heroImg, 'hero');
  const sigImg = document.getElementById('sigImg');
  if (sigImg) applyImage(sigImg.closest('.signature'), 'signature', '.signature__img');

  // generic [data-img] slots
  document.querySelectorAll('[data-img]').forEach(function (el) {
    const key = el.getAttribute('data-img');
    // choose the inner image node per component
    const inner =
      el.querySelector('.col-card__img') ? '.col-card__img' :
      el.querySelector('.craft__step-img') ? '.craft__step-img' :
      null;
    applyImage(el, key, inner);
  });

  /* ---- Scroll reveal ---- */
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---- Word-by-word manifesto reveal ---- */
  const words = document.querySelectorAll('.reveal-word');
  if (words.length) {
    const wio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        words.forEach(function (w, i) {
          w.style.transitionDelay = (i * 0.09) + 's';
          w.classList.add('in');
        });
        wio.disconnect();
      });
    }, { threshold: 0.5 });
    wio.observe(words[0]);
  }

  /* ---- Light parallax ---- */
  const layers = document.querySelectorAll('[data-parallax] .hero__img, [data-parallax] .signature__img');
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      layers.forEach(function (layer) {
        const rect = layer.getBoundingClientRect();
        const speed = 0.14;
        const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
        layer.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    });
  }, { passive: true });

})();
